import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const RedirectComponent = () => {
  const { search } = window.location;

  // This was added to ensure the redirect from /referral to /free-bag is handled by the static referral page
  // The same has been added in static.json to ensure efficient redirects in production environment
  if ((window.location.pathname === '/referral' || window.location.pathname === '/referral/') && !search) {
    window.location.replace('/free-bag');
  }

  return <></>;
};

RedirectComponent.propTypes = {
  me: PropTypes.object,
};

export const Redirect = connect(({ user: { me } }) => ({ me }))(RedirectComponent);
